import { render } from "./editable-field.vue?vue&type=template&id=4f833b5e"
import script from "./editable-field.vue?vue&type=script&lang=js"
export * from "./editable-field.vue?vue&type=script&lang=js"

import "./editable-field.vue?vue&type=style&index=0&id=4f833b5e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__